import { registerSettingComponent, registerWidget } from "dmeditor";
import definition from "./definition";
import { NewsList, onServerLoad } from "./NewsList";
import Number from "./settings/Number";

const register = () => {
  registerSettingComponent("number", Number);
  registerWidget(definition, {
    render: NewsList,
    onServerSideLoad: onServerLoad,
  });
};

export default register;
